/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from '../Icon';

import './style.scss';

export class ToastElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGoingToBeRemoved: false
    };

    this.cancelCounting = this.cancelCounting.bind(this);
    this.startCounting = this.startCounting.bind(this);
    this.remove = this.remove.bind(this);
    this.forceRemove = this.forceRemove.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.startCounting();
  }

  componentDidUpdate(_, prevState) {
    const { isGoingToBeRemoved } = this.state;

    if (prevState.isGoingToBeRemoved !== isGoingToBeRemoved) {
      this.cancelCounting();
      setTimeout(this.remove, 200);
    }
  }

  handleClick() {
    const { options } = this.props;
    const { onClick } = options;

    if (onClick) {
      onClick();
    }

    this.forceRemove();
  }

  startCounting() {
    const { options } = this.props;
    const { time } = options;

    this.timeOut = setTimeout(() => {
      this.setState({ isGoingToBeRemoved: true });
    }, time);
  }

  cancelCounting() {
    clearTimeout(this.timeOut);
  }

  forceRemove() {
    this.setState({ isGoingToBeRemoved: true });
  }

  remove() {
    const { removeElements } = this.props;
    const { isGoingToBeRemoved } = this.state;
    if (isGoingToBeRemoved) {
      removeElements();
    }
  }

  render() {
    const { color, children, options } = this.props;
    const { isGoingToBeRemoved } = this.state;
    const { iconName, iconAlt } = options;

    const styleName = cx({
      toast: true,
      primary: color === 'primary',
      success: color === 'success',
      info: color === 'info',
      warning: color === 'warning',
      danger: color === 'danger',
      show: !isGoingToBeRemoved,
      remove: isGoingToBeRemoved
    });

    return (
      <button
        id="toast-button"
        tid="toast-container"
        styleName={styleName}
        onClick={this.handleClick}
        type="button"
      >
        {
          iconName && <Icon name={iconName} height={25} width={25} alt={iconAlt} styleName="icon" />
        }
        {children}
      </button>
    );
  }
}

const createToast = (color, children, options) => {
  const toastRoot = document.getElementById('toast');

  const removeElements = () => {
    ReactDOM.unmountComponentAtNode(toastRoot);
  };

  ReactDOM.render(
    <ToastElement
      color={color}
      options={options}
      removeElements={removeElements}
    >
      {children}
    </ToastElement>,
    toastRoot
  );
};

const toast = (children, options) => createToast('primary', children, options);
toast.success = (children, options) => createToast('success', children, options);
toast.info = (children, options) => createToast('info', children, options);
toast.warning = (children, options) => createToast('warning', children, options);
toast.danger = (children, options) => createToast('danger', children, options);

ToastElement.defaultProps = {
  options: {
    time: 3000,
    iconName: '',
    iconAlt: '',
    onClick: null
  }
};

ToastElement.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  options: PropTypes.shape({
    time: PropTypes.number,
    iconName: PropTypes.string,
    iconAlt: PropTypes.string,
    onClick: PropTypes.func
  }),
  removeElements: PropTypes.func.isRequired
};

export default toast;
